import CMS from 'netlify-cms-app'
import CSSInjector from "./CSSInjector.js"

import IndexPagePreview  from './preview-templates/index-page-preview.js'
import ImprintPagePreview from './preview-templates/imprint-page-preview.js'
import PrivacyPagePreview from './preview-templates/privacy-page-preview.js'

CMS.registerPreviewTemplate('index', CSSInjector(IndexPagePreview))
CMS.registerPreviewTemplate('imprint', CSSInjector(ImprintPagePreview))
CMS.registerPreviewTemplate('privacy', CSSInjector(PrivacyPagePreview))
CMS.init()